var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_sidinnehall_snabbval-container",
      class: { focus: _vm.isInFocus },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
          ) {
            return null
          }
          _vm.isTabbed = true
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "inputSlot",
          staticClass: "input-wrapper",
          on: {
            click: _vm.showSuggestions,
            input: _vm.onInput,
            keydown: function($event) {
              _vm.moveSelection($event), _vm.onAutocomplete($event)
            },
            keyup: _vm.onListKeyUp
          }
        },
        [
          _vm._t("default", [
            _c("input", {
              ref: "shadow",
              staticClass: "shadow",
              attrs: { type: "text", readonly: "" },
              domProps: { value: _vm.shadowValue }
            }),
            _vm._v(" "),
            !_vm.isTouchDevice
              ? _c(
                  "input",
                  _vm._b(
                    {
                      ref: "input",
                      attrs: {
                        type: "text",
                        placeholder: "Snabbval",
                        name: "snabbval",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.text || "" }
                    },
                    "input",
                    _vm.$props,
                    false
                  )
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isTouchDevice
              ? _c(
                  "input",
                  _vm._b(
                    {
                      ref: "input",
                      attrs: {
                        type: "text",
                        placeholder: "Snabbval",
                        name: "snabbval",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.text || "" }
                    },
                    "input",
                    _vm.$props,
                    false
                  )
                )
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      !!_vm.listShown && !_vm.removeList
        ? _c(
            "div",
            {
              staticClass: "suggestions",
              on: {
                mouseenter: function($event) {
                  return _vm.hoverList(true)
                },
                mouseleave: function($event) {
                  return _vm.hoverList(false)
                }
              }
            },
            _vm._l(_vm.suggestions, function(suggestion) {
              return _c(
                "div",
                {
                  key: suggestion.Id,
                  staticClass: "suggest-item",
                  class: {
                    selected: _vm.selected && suggestion.Id == _vm.selected.Id,
                    hover: _vm.hovered && _vm.hovered.Id == suggestion.Id
                  },
                  on: {
                    mouseenter: function($event) {
                      return _vm.hover(suggestion, $event.target)
                    },
                    mouseleave: function($event) {
                      return _vm.hover(null, $event.target)
                    },
                    click: function($event) {
                      return _vm.suggestionClick(suggestion, $event)
                    }
                  }
                },
                [
                  _vm._t(
                    "suggestion-item",
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(suggestion.Id) +
                            " – " +
                            _vm._s(suggestion.Name)
                        )
                      ])
                    ],
                    {
                      autocomplete: function() {
                        return _vm.autocompleteText(suggestion)
                      },
                      suggestion: suggestion,
                      query: _vm.text
                    }
                  )
                ],
                2
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }